import { Outlet, useLocation } from "react-router-dom";
import Footer from '../components/Footer';
import Header from '../components/Header';
import React from 'react';
const Layout = () => {
  const location = useLocation();
  const blackHeaderRoutes = [
    "/404/",
    "/thank-you/",
    "/disclaimer/",
    "/privacy-policy/",
    "/career-form/",
    "/careers/",
  ];

  const noFooterRoutes = [
    "/404/",
    "/thank-you/",
  ];

  const noHeaderRoutes = [
    "/luxury-interior-designer-gurgaon/"
  ];

  const isBlackHeader = blackHeaderRoutes.includes(location.pathname);
  const hideFooter = noFooterRoutes.includes(location.pathname);
  const hideHeader = noHeaderRoutes.includes(location.pathname);


  return (
    <div className={`${isBlackHeader ? "header-black-link" : ""}`}>
      {!hideHeader && <Header />}
      <main>
        <Outlet />
      </main>
      {!hideFooter && <Footer />}
    </div>
  );
};

export default Layout;
